import api from '@/utils/api';
import { STORAGE_KEYS } from '@/config/storage-keys';
import type { SwitchableAccount, User } from '@/types/auth';

/**
 * Switching between accounts that share one email — a channel partner and the
 * end-customer account auto-provisioned when they signed their own proposal, for
 * instance. Works in every direction, unlike the two account-type-specific
 * endpoints this replaces.
 */

/** Every account the signed-in email can enter. Carries no tokens by design. */
export const getSwitchableAccounts = async (): Promise<SwitchableAccount[]> => {
  return (await api.get('/auth/switchable-accounts')).data?.data?.accounts || [];
};

export type SwitchAccountResponse = {
  accessToken: string;
  refreshToken?: string;
  user: User;
  availableAccounts: SwitchableAccount[];
};

/**
 * Enter another of the signed-in email's accounts. The current refresh token is
 * sent so the server can revoke it — the session being left must not keep a usable
 * one behind.
 */
export const switchAccount = async (userId: string): Promise<SwitchAccountResponse> => {
  const refreshToken = localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN) || undefined;
  return (await api.post('/auth/switch-account', { userId, refreshToken })).data.data;
};
